var render = function render(_c,_vm){return _c('span',{class:[
    _vm.data.class,
    _vm.data.staticClass,
    `skeleton h-${_vm.props.height} w-${_vm.props.width} ${_vm.props.radius} bg-gray inline-block align-middle relative overflow-hidden`,
  ]})
}
var staticRenderFns = []

export { render, staticRenderFns }